<template>
    <b-container fluid style="padding-top: 10px">
        <b-modal id="modal-1" title="Certification Details" effect="fade/zoom" hide-footer>
            <div class="parent">
                <p class="my-4">Select the date of certification.</p>
                <b-row>
                    <b-col cols="2"/>
                    <b-col cols="8">
                        <datepicker v-model="certificationDate" name="certDatePicker" :inline="true"
                                    style="width: 50%"/>
                    </b-col>
                    <b-col cols="2"/>
                </b-row>
                <div slot="modal-footer" class="modal-footer">
                    <button type="submit" class="btn btn-success" @click="saveAction">Save</button>
                    <button type="button" class="btn btn-default" @click="dismissTheModal">Cancel</button>
                </div>
            </div>
        </b-modal>

        <vue-good-table
                ref="questionnaireTable"
                :columns="columns"
                :rows="rows"
                :groupOptions="{
                 enabled: true,
                headerPosition: 'top',
                 collapsable: 7
                }"
                :sort-options="{
                    enabled: true,
                    collapsable: true
                }"
                :defaultSortBy="{field: 'status', type: 'certificationDate'}"
                styleClass="vgt-table condensed table-bordered table-striped"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200,500],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page',
                    allLabel: 'All',
                }"
                :totalRows="totalRecords"
                @on-row-click="onRowClick"
                @on-page-change="onPageChange">
            <template slot="table-header-row" slot-scope="props">
                <span style="color: green;" v-html="getStatusIcon(props.row.label, props.row.groupStatus || 'ENROLLED', props.row.groupStatusDate)">
            </span>
                <b-button size="sm" :disabled="!isAdminOrCertifier() || !props.row.groupId"
                          @click.stop="toggleCertificationStatus(props.row.groupId, props.row.groupStatus || 'ENROLLED', props.row.label)">
                    {{ (props.row.groupStatus || 'ENROLLED') === 'CERTIFIED' ? 'Decertify' : 'Certify' }}
                </b-button>
            </template>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'Admin Account Info'">
                    <b-button size="sm"
                              @click="goToAdminAccountInfo(props.column.field,props.formattedRow[props.column.field])">
                            Admin Account Info
                </b-button>
                </span>
                <span v-else-if="props.column.label === 'Standards Pdf'">
                    <b-button size="sm"
                              @click.stop="downloadStandardsPdf(props.row['winery'],props.formattedRow[props.column.field],props.row['surveyResponseId'])">
                            Download Standards
                </b-button>
                </span>
                <span v-else-if="props.column.label === 'Calculator'">
                    <b-button size="sm"
                              @click="goToCalculatorNew(props.formattedRow[props.column.field],props.row['entityType'])">
                        Metrics Calculator
                    </b-button>
                </span>
                <span v-else-if="props.column.label === 'Certify'">
                    <b-button size="sm" :disabled="!isAdminOrCertifier()"
                              @click.stop="certify(props.row['surveyResponseId'],props.column.field, props.formattedRow['groupId'], props.formattedRow['status'], props)">
                        Certify
                    </b-button>
                </span>
                <span v-else>
                        {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </vue-good-table>
    </b-container>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import Swal from 'sweetalert2';
import {isAdminOrCertifier, isNotCertifier} from '@/lib/UserUtils';

export default {
  name: "QuestionnaireAdmin.vue",
  components: {
    Datepicker,
    VueGoodTable
  },
  data() {
    return {
      countyMap: [{text: "", value: null},
        {text: "Napa", value: 28},
        {text: "Lake", value: 17},
        {text: "Marin", value: 21},
        {text: "Mendocino", value: 23},
        {text: "Sonoma", value: 49},
        {text: "Solano", value: 48}],
      columns: [
        {
          label: "winery",
                    field: "winery",
                    filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: 'Winery', // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                    }
                  },
                  {
                    label: "Org Type",
                    field: "entityType",
                    filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: 'Org Type', // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                    }
                  },
                  {
                    label: "contactName",
                    field: "contactName"
                  },
        {
          label: "county",
          field: "county",
          formatFn: value => {
            console.log("county: ", value)
            let val = value ? parseInt(value, 10) : value;
            return this.countyMap.filter(county => {
              return county.value === val;
            }).find(x => {
              return x !== undefined
            }).text;
          },
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterDropdownItems: [{text: "", value: null}, {text: "Napa", value: "28"}, {
              text: "Sonoma",
              value: "49"
            },
              {text: "Solano", value: "48"}],
          }
        },
                  {
                    label: "email",
                    field: "email"
                  },
                  {
                    label: "Status",
                        field: "status",
                        formatFn: value => {
                          return (value !== undefined) && (value !== null) ? value.replace("_", " ") : "UNKNOWN";
                        },
                    filterOptions: {
                      enabled: true, // enable filter for this column
                      placeholder: 'Status', // placeholder for filter input
                      filterDropdownItems: [{value: 'IN_PROGRESS', text: 'IN PROGRESS'},
                        {value: 'CERTIFIED', text: 'CERTIFIED'},
                        {value: 'AWAITING_START', text: 'AWAITING START'}]
                    }
                  },
        {
          label: "Parent Company",
          field: "parentCompany",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Parent Company', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Certification Date",
          field: "certDate",
          type: 'date',
          dateInputFormat: 'yyyy/MM/dd',
          dateOutputFormat: 'MMM dd yy',
        },
        {
          label: "Admin Account Info",
          field: "groupId"
        },
                {
          label: "Standards Pdf",
          field: "groupId"
        },
        {
          label: "Certify",
          field: "surveyId",
        }],
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      currentPerPage: 50,
      certificationDate: '',
      surveyToCertify: '',
      groupIdToCertify: '',
      useBeta: false
    }
  },
  mounted() {
    let notCertifier = isNotCertifier();
    if (notCertifier) {
      this.columns.push({
        label: "Calculator",
        field: "groupId"
      });
    }
    this.loadChecklists();
    this.$set(this.columns[7], 'hidden', !isAdminOrCertifier())

        },
        methods: {
          isAdminOrCertifier,
          getStatusIcon: function (label, icon, statusDate) {
            let iconName = this.getIcon(icon);
            let iconColor = this.getColor(icon);
            let dateText = statusDate ? ` (as of ${statusDate})` : '';
            //return label + ' &nbsp;&nbsp;&nbsp;&nbsp;  Current Status:&nbsp;' + icon + ' <i class="' + iconName + '" aria-hidden="true" style="color:' + iconColor + ';"/> ';
            return `${label}  &nbsp;&nbsp;&nbsp;&nbsp;  Current Status:&nbsp; ${icon}${dateText} <i class=" ${iconName}" aria-hidden="true" style="color: ${iconColor};"/> `;
          },
          getColor: function (value) {
            let normalized = (value || '').replace(/-/g, '_');
            if (normalized === "CERTIFIED") {
              return 'green';
            } else if (normalized === "IN_PROGRESS" || normalized === "ENROLLED") {
              return 'orange';
                } else if (normalized === "UN_CERTIFIED" || normalized === "EXPIRED") {
                    return 'red';
                } else if (normalized === "GRACE") {
                    return 'red';
                } else if (normalized === "DECERTIFIED") {
                    return 'red';
                }
                return 'gray';
            },
            getIcon: function (value) {
                let normalized = (value || '').replace(/-/g, '_');
                if (normalized === "CERTIFIED") {
                    return 'fa fa-trophy';
                } else if (normalized === "IN_PROGRESS") {
                    return 'fa fa-coffee';
                } else if (normalized === "UN_CERTIFIED" || normalized === "EXPIRED") {
                    return 'fa fa-skull-crossbones';
                } else if (normalized === "GRACE") {
                    return 'fa fa-medkit';
                } else if (normalized === "ENROLLED") {
                    return 'fa fa-coffee';
                } else if (normalized === "DECERTIFIED") {
                    return 'fa fa-ban';
                }
                return 'fa fa-question';
            },
            selected(item) {
                localStorage.setItem('adminImpersonationGroupId', item.groupId);
              this.$store.commit("adminImpersonationGroupId", item.groupId);
                this.$router.push({name: 'SurveyLink', params: {surveyKey: item.surveyId, groupId: item.groupId}});//path: '/survey' + item.surveyId});
            },
            onRowClick(params) {
                let row = params.row;
                localStorage.setItem('adminImpersonationGroupId', row.groupId);
              this.$store.commit("adminImpersonationGroupId", row.groupId);
              localStorage.setItem('adminImpersonationEntityType', row.entityType);
              this.$store.commit("adminImpersonationEntityType", row.entityType);
              console.log(params.entityType);

                  this.$router.push({
                    name: 'Vineyard Page',
                    params: {surveyKey: row.surveyId, groupId: row.groupId, mySurveyResponseId: row.surveyResponseId}
                  });
            },
            certify: function (surveyIdValue, wineryName, groupId, status, props) {
            console.log(`Props: ${props}`)
                if (status !== 'CERTIFIED') {
                  this.$bvModal.show("modal-1");
                    this.surveyToCertify = surveyIdValue;
                    this.groupIdToCertify = groupId;
                } else {
                    Swal.fire({
                        title: 'Certification Failure',
                        text: 'This Checklist Is Already Certified.',
                        icon: 'error'
                    });
                }

            },
            toggleCertificationStatus: function (groupId, currentStatus, label) {
                let targetAction = currentStatus === 'CERTIFIED' ? 'DECERTIFIED' : 'CERTIFIED';
                return Swal.fire({
                    title: `${targetAction === 'CERTIFIED' ? 'Certify' : 'Decertify'} ${label}?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    // sweetalert2@9.7.2 (the version actually installed here) has no
                    // result.isConfirmed - that was added in a later 9.x release.
                    // Confirming resolves with {value: true}, per the working pattern
                    // used elsewhere in this codebase (see AnnualUpdate.vue deleteFile).
                    if (result.value) {
                        let request = {
                            certifierId: localStorage.getItem('user'),
                            groupId: groupId,
                            certificationDate: new Date(),
                            action: targetAction
                        };
                        this.$http.post("survey/certification-status", JSON.stringify(request), {
                            headers: {'content-type': 'application/json'}
                        }).then(() => {
                            Swal.fire({
                                title: `Group status updated to ${targetAction}`,
                                icon: 'success',
                                timer: 3000
                            });
                            this.loadChecklists();
                        }).catch(fail => {
                            Swal.fire('Status Update Failed', 'Exception: ' + fail, 'error');
                        });
                    }
                });
            },
          goToCalculator: function (group, entityType) {
            localStorage.setItem('adminImpersonationGroupId', group);
            this.$store.commit("adminImpersonationGroupId", group);
            localStorage.setItem('adminImpersonationEntityType', entityType);
            this.$store.commit("user/adminImpersonationEntityType", entityType);
            console.log(`Entity Type: ${entityType}`);
            this.$router.push({name: "TabbedMetrics", params: {groupId: group}})
                .catch(err => {
                  this.$toasted.show(`Unable to navigate to the Metrics Pages, with error: ${err}`,
                      {
                        containerClass: 'super-toasty',
                        iconPack: 'fontawesome',
                        closeOnSwipe: true,
                        action: {
                          text: 'DISMISS',
                          onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                          }
                        },
                        icon: {
                          name: 'fa-error',
                          after: false,
                        }
                      })
                      .goAway(5000);
                });
          },
          goToCalculatorNew: function (group, entityType) {
            localStorage.setItem('adminImpersonationGroupId', group);
            this.$store.commit("adminImpersonationGroupId", group);
            localStorage.setItem('adminImpersonationEntityType', entityType);
            this.$store.commit("user/adminImpersonationEntityType", entityType);
            this.$store.commit("currentMetricsGroupId", group);
            this.$router.push({name: "SingleMetric", params: {groupId: group}})
                .catch(err => {
                  this.$toasted.show(`Unable to navigate to the Metrics Pages, with error: ${err}`,
                      {
                        containerClass: 'super-toasty',
                        iconPack: 'fontawesome',
                        closeOnSwipe: true,
                        action: {
                          text: 'DISMISS',
                          onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                          }
                        },
                        icon: {
                          name: 'fa-error',
                          after: false,
                        }
                      })
                      .goAway(5000);
                });
          },
            goToAccountInfo: function (wineryName, groupId) {
                localStorage.setItem('adminImpersonationGroupId', groupId);
              this.$store.commit("adminImpersonationGroupId", groupId);
                this.$router.push({name: "Update_Account", params: {groupId: groupId}})
                    .catch(err => {
                      console.log("Could not got to Update Account page", err);
                    });
            },
          goToAdminAccountInfo: function (wineryName, groupId) {
            localStorage.setItem('adminImpersonationGroupId', groupId);
            this.$store.commit("adminImpersonationGroupId", groupId);
            this.$router.push({name: "AdminUpdateAccount", params: {groupId: groupId}})
                .catch(err => {
                  console.log("Could not got to AdminUpdateAccount page", err);
                });
          },
          downloadStandardsPdf: function (wineryName, groupIdToDownload, responseId) {
            console.log(`About to download PDF for group[${wineryName}].`)
            ///////////////////////////////////////////////////////
            this.$toasted.show('Standards download has begun...Please wait.',
                {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-check-circle',
                    after: false,
                  }
                })
                .goAway(5000);

            ///////////////////////////////////////////////////////

            this.$http.get(`survey/pdf/download/${groupIdToDownload}/response/${responseId}`, {responseType: "blob"})
                .then(async response => {

                  const blob = new Blob([response.data], {type: "application/pdf"});
                  const link = document.createElement("a");
                  link.href = URL.createObjectURL(blob);
                  let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
                  let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
                  link.download = `${filename}.${extension}`.replaceAll("\"", "");
                  console.log(`Filename: ${filename}.${extension}`);
                  link.click();
                  URL.revokeObjectURL(link.href);
                })
              .catch(error=>{
                  console.log('Unable to download pdf.',error.message);
                this.$toasted.error("Unable to Download Standards!!", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  }
                  , icon: {
                      name: 'fa-error',
                      after: false
                    }
              })
              .goAway(5000);
              });
            },
            dismissTheModal: function () {
                this.$bvModal.hide("modal-1");
                this.surveyToCertify = '';
                this.groupIdToCertify = '';
                this.certificationDate = '';
            },
            saveAction: function () {
                this.$bvModal.hide("modal-1");
                let certRequest = {
                    certificationDate: new Date(this.certificationDate),
                    surveyResponseId: this.surveyToCertify,
                    certifierId: localStorage.getItem('user'),
                    groupId: this.groupIdToCertify
                }
                let inviteRequestJson = JSON.stringify(certRequest, null, 3);
                this.$http.post("survey/certify", inviteRequestJson
                    , {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                    .then(response => {
                        console.log(response);
                      Swal.fire({
                        title: "Group has been Certified",
                        type: "success",
                        timer: 3000
                      });
                      // Reload only after the server has actually processed the
                      // certification - the group's overall status (and its status
                      // date) doesn't change until then, so reloading any earlier
                      // just re-fetches the stale, pre-certify status.
                      this.loadChecklists();
                    })
                    .catch(fail => {
                      Swal.fire(" Certification Attempt Failed.", " Exception: " + fail, "error");
                    });
            },
            loadChecklists: function () {
                this.$http.get("survey/meta/good")
                    .then(result => {
                      this.rows = result.data.rows;
                      this.totalRecords = result.data.total;
                      // Reassigning rows makes vue-good-table re-evaluate its
                      // pagination and, if it thinks the current page is no longer
                      // valid, snap back to page 1 on its own. Restore whatever
                      // page (and page size) the admin was actually looking at,
                      // rather than losing their place on every reload.
                      this.restoreCurrentPage();
                    })
                    .catch(error => {
                        console.log("The error: " + error);
                    })
            },
            onPageChange: function (params) {
                this.currentPage = params.currentPage;
                this.currentPerPage = params.currentPerPage;
            },
            restoreCurrentPage: function () {
                this.$nextTick(() => {
                    let table = this.$refs.questionnaireTable;
                    if (!table || typeof table.changePage !== 'function') {
                        return;
                    }
                    let perPage = this.currentPerPage || 50;
                    let maxPage = Math.max(1, Math.ceil(this.totalRecords / perPage));
                    let pageToRestore = Math.min(this.currentPage, maxPage);
                    table.changePage(pageToRestore);
                });
            }
        }
    }
</script>
